import React, { useState, useEffect, Fragment } from "react";
import { Tabs, Badge, Tooltip, Spin, Empty } from "antd";
import { 
  AppstoreOutlined, 
  CodeOutlined, 
  ApiOutlined, 
  RocketOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import FlowEditor from "./FlowEditor";
import useEditorStore from "@/store/useEditorStore";
import styled from 'styled-components';

const StyledContainer = styled.div`
  .flow-tabs-custom .ant-tabs-tab {
    transition: all 0.3s;
    border-radius: 4px;
    margin: 4px 8px !important;
    padding: 4px 8px !important;
  }
  
  .flow-tabs-custom .ant-tabs-tab:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  
  .flow-tabs-custom .ant-tabs-tab-active {
    background-color: rgba(24, 144, 255, 0.1);
  }
  
  .flow-tabs-custom .ant-tabs-ink-bar {
    display: none;
  }
`;

function FlowTabs({ onDbClick, formid, updateNodeProps, hide }) {
  const flowlist = useEditorStore.use.flowlist();
  const getFlowList = useEditorStore.use.getFlowList();
  const activeFlow = useEditorStore.use.activeFlow();
  const setActiveFlow = useEditorStore.use.setActiveFlow();
  const resetSVGPosition = useEditorStore.use.resetSVGPosition();
  const saveFlowPosition = useEditorStore.use.saveFlowPosition();
  const restoreFlowPosition = useEditorStore.use.restoreFlowPosition();
  const flowPositions = useEditorStore.use.flowPositions();
  // 移除本地loading状态，使用全局loading状态
  const [hoveredTab, setHoveredTab] = useState(null);

  useEffect(() => {

    
    getFlowList();
  }, []);

  const handleTabChange = (key) => {
    // 保存当前流程的位置
    if (activeFlow) {
      saveFlowPosition(activeFlow);
    }
    setActiveFlow(key);
    // 重置 SVG 位置到初始状态
    setTimeout(() => {
      if (flowPositions[key]) {
        restoreFlowPosition(key);
      } else {
        resetSVGPosition();
      }
    }, 0);
  };

  // 为不同类型的流程选择不同的图标
  const getFlowIcon = (flowName) => {
    if (flowName.includes('api') || flowName.includes('http')) {
      return <ApiOutlined />;
    } else if (flowName.includes('core') || flowName.includes('main')) {
      return <RocketOutlined />;
    } else if (flowName.includes('util') || flowName.includes('helper')) {
      return <CodeOutlined />;
    }
    return <AppstoreOutlined />;
  };

  const items = flowlist.map((flow) => ({
    label: (
      <div 
        className={`flow-tab-item flex items-center py-2 px-1 transition-all duration-300 ${activeFlow === flow ? 'text-blue-600 font-medium' : 'text-gray-600'}`}
        onMouseEnter={() => setHoveredTab(flow)}
        onMouseLeave={() => setHoveredTab(null)}
      >
        <span className="mr-2">{getFlowIcon(flow)}</span>
        <Tooltip title={flow} placement="right">
          <span className="truncate max-w-[100px]">{flow}</span>
        </Tooltip>
        {/* 使用固定宽度的占位符，避免徽章显示/隐藏时造成宽度变化 */}
        <span className="ml-2 w-[20px] flex justify-end">
          {hoveredTab === flow && (
            <Badge 
              count={Math.floor(Math.random() * 10)} 
              size="small" 
              className="opacity-70"
              style={{ backgroundColor: '#52c41a' }}
            />
          )}
        </span>
      </div>
    ),
    key: flow,
  }));

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <StyledContainer className="wsc-layout-bg p-4 h-[calc(100vh-5.3rem)] w-[calc(100vw-12.5rem)] overflow-y-auto bg-gray-50">
      <div className="flex flex-row justify-between h-full rounded-lg shadow-sm bg-white">
        {/* 移除loading条件渲染，直接显示内容 */}
        <>
          <div className="border-r border-gray-200 bg-gray-50 rounded-l-lg">
            <div className="py-3 px-4 border-b border-gray-200 bg-gray-100 rounded-tl-lg">
              <h3 className="text-sm font-medium text-gray-700">流程管理</h3>
            </div>
            {flowlist.length > 0 ? (
              <Tabs
                activeKey={activeFlow}
                onChange={handleTabChange}
                items={items}
                tabPosition="left"
                destroyInactiveTabPane={true}
                className="flow-tabs-custom"
                tabBarStyle={{ 
                  borderRight: 'none',
                  margin: '0',
                  padding: '8px 0'
                }}
              />
            ) : (
              <div className="p-4">
                <Empty 
                  image={Empty.PRESENTED_IMAGE_SIMPLE} 
                  description="暂无流程" 
                />
              </div>
            )}
          </div>
          <div className="flex-1 p-2 overflow-hidden">
            {activeFlow ? (
              <FlowEditor flow={activeFlow} />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                请选择一个流程
              </div>
            )}
          </div>
        </>
      </div>
    </StyledContainer>
  );
}

export default FlowTabs;